const MobileNav = {
	init: () => {
		const me = MobileNav
		const mn = (<HTMLElement>document.querySelector('.mobile-nav'))

		if (mn) {
			me.handleMobileNav(mn)
		}
	},
	handleMobileNav: (nav: HTMLElement) => {
		const openTrigger = document.querySelector('.mobile-nav-trigger')
		const closeTrigger = document.querySelector('.mobile-nav__close')

		if (openTrigger) {
			openTrigger.addEventListener('click', () => {
				MobileNav.openNav(nav)
			})
		}

		if (closeTrigger) {
			closeTrigger.addEventListener('click', () => {
				MobileNav.closeNav(nav)
			})
		}
	},

	openNav: (nav: HTMLElement) => {
		nav.classList.add('mobile-nav__open')
	},
	closeNav: (nav: HTMLElement) => {
		nav.classList.remove('mobile-nav__open')
	}
}

export default MobileNav
